module.exports = {"Personnel":"پرسنل","PersonnelId":"کد پرسنلی"}